<template>
    <div id="ContainerCustomExports">
        <MdTitle v-bind:Text="title" />
        <b-row v-if="filters.length !== 0">
            <b-col md="3" lg="3" sm="12" v-for="(filter,index) in filters" :key="index">
                <MdEdit v-if="filter.controlType == 'ctDate'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'date'" 
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isValid="filter.isValid"
                    :ref="`ctDate_${index}`"
                    v-bind:isRequired="true"
                    :OnPressEnter="onDatePressEnter"
                >                                     
                </MdEdit>
                <MdEdit v-if="filter.controlType == 'ctNumber'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'number'" 
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >
                </MdEdit>
                <MdEdit v-if="filter.controlType == 'ctEdit'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >                                     
                </MdEdit>
                <MdCheckBox v-if="filter.controlType == 'ctCheckBox'"
                    v-bind:Label="filter.caption"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                >
                </MdCheckBox>
                <MdSelect v-if="filter.controlType == 'ctCombo'"
                    v-bind:Label="filter.caption"
                    v-bind:Options="filter.itemList"
                    v-bind:FieldDescription="'value'"
                    v-bind:FieldCode="'key'"
                    v-bind:Multiple="false"
                    v-bind:Model="filter.controlValue"
                    v-bind:UseParamsAux="true"
                    v-bind:AuxParam="filter"
                    :Input="changeDropDown"
                    v-bind:Name="`ctCombo_${index}`"
                    v-bind:Id="`ctCombo_${index}`"
                >
                </MdSelect>
                <MdEdit v-if="filter.controlType == 'ctMemo'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctMemo_${index}`"
                    v-bind:Id="`ctMemo_${index}`"
                >                                     
                </MdEdit>
                <MdRadioGroup v-if="filter.controlType == 'ctRadio'"
                    v-bind:Label="filter.caption"
                    v-model="filter.controlValue"
                    v-bind:Options="filter.itemList"
                >
                </MdRadioGroup>
            </b-col>
        </b-row>

        <div class="row" v-if="filters.length !== 0">
            <b-col md="12">
                <div class="text-center text-md-right mt-3">
                    <MdButton
                        v-bind:Label="$t('Shared.Search')"
                        v-bind:ClassProp="'primary btn-login mx-2'"
                        v-bind:isReadOnly="isReadOnly"
                        v-on:click="search"
                        v-bind:Name="'btn_search'"
                    />
                </div>
            </b-col>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-if="filters.length !== 0"
                    v-bind:Text="$t('Shared.SearchResult')" 
                    v-bind:isSubtitle="true" 
                    v-bind:Name="'T_TitleSearch'"
                />
                <MdTable 
                    v-bind:refTable="'refCustomReport'"
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:isReadOnly = "true"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                </MdTable>
            </div>
        </div>
        
        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="gotoCustomExportsList"
                v-bind:Name="'btn_CustomExportsList'"/>   

            <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
                <b-dropdown-item v-on:click="exportToCSV()">{{$t('Shared.CSV')}}</b-dropdown-item>
                <b-dropdown-item v-on:click="shareByEmailCSV()">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
			</b-dropdown>                
        </div>
        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="conformSubject"
            v-bind:sendEmailAPI="'/CustomExports/email'"
            v-bind:exportCsvAPI="'/CustomExports/exportCSV'"
        >    
        </CSVExportHelper>
    </div>
</template>

<script>
import Permission from '@/common/Permission'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import CustomExportsService from '@/services/customExports.service'
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'CustomExports',

    data () {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            customExportsItem: {
                description: ''
            },
            filters: [],
            dataRows: [],
            dataColumns: [],
            fields: [],
            items: [],
            ShowMessageIsEmpty: true,
            currentPage: 1,
            perPage: 10,
            totalRows: 0, 
            pageOptions: [5,10,20,30,40,50],
            resetField: true
        }
    },

    computed: {
        fieldTile() {
            return this.customExportsItem?.description ?? '';
        },

        title() {
            return this.$t('CustomExports.Title', {'title': this.customExportsItem.description});
        },

        isReadOnly() {
            return Utils.isNullOrEmptyString(this.customExportsItem.code);
        },

        conformSubject() {
            return this.customExportsItem?.description;
        }
    },

    methods: {
        gotoCustomExportsList() {
            this.$router.push({
                name: "customExportsList"
            }).catch(()=>{});
        },

        search() {
            if (this.validateFilters()) {
                this.$emit('load', true);
                let parameters = this.filters.map(x => 
                    x.controlType == 'ctDate' ? Utils.formatterDate(x.controlValue) : 
                        x.controlType == 'ctCombo' ? (x.controlValue != null && x.controlValue != undefined ? x.controlValue.key : '') : 
                        x.controlValue
                );
                parameters.reverse();

                CustomExportsService.execute({id: encodeURIComponent(this.$route.params.id), parameters, PageSize: this.perPage, PageNumber: this.currentPage})
                    .then((response) => {
                        if (response.status == '200' && response.data) {
                            this.dataRows = response.data.rows ?? [];
                            this.dataColumns = response.data.columns ?? [];
                            this.totalRows = response.data.totalCount;
                            this.ShowMessageIsEmpty = this.dataRows.length == 0 ? true : false;
                            
                            this.generateFields();
                            this.populateItems();
                        }

                        this.$emit('load', false);
                    })
                    .catch((error) => {
                        if (this.fields.length === 0) {
                            setTimeout(() => {
                                this.fields.push({ key: 'label', sortable: false, label: this.fieldTile, class: 'text-rigth' });
                            }, 10);
                        }
                        
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
            }
        },

        shareByEmailCSV() {
            if (this.validateFilters()) {
                let parameters = this.filters
                                .map(x => 
                                        x.controlType == 'ctDate' ? Utils.formatterDate(x.controlValue) : 
                                            x.controlType == 'ctCombo' ? (x.controlValue != null && x.controlValue != undefined ? x.controlValue.key : '') : 
                                            x.controlValue
                                );
                parameters.reverse();

                this.$refs.csvExportHelper.emailCSV({id: encodeURIComponent(this.$route.params.id), parameters});
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
            }
        },

        exportToCSV() {
            if (this.validateFilters()) {
                let parameters = this.filters.map(x => 
                    x.controlType == 'ctDate' ? Utils.formatterDate(x.controlValue) : 
                        x.controlType == 'ctCombo' ? (x.controlValue != null && x.controlValue != undefined ? x.controlValue.key : '') : 
                        x.controlValue
                );
                parameters.reverse();

                this.$refs.csvExportHelper.exportCSV({id: encodeURIComponent(this.$route.params.id), parameters});   
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
            }
        },

        async getCustomExports() {
            this.$emit('load', true);
            await CustomExportsService.get(this.$route.params.id)
                .then((response) => {
                    if (response.status == '200' && response.data) {
                        this.customExportsItem = response.data;
                        this.customExportsItem.parameters.forEach((param) => {
                            param.isValid = true;
                            if (param.controlType == 'ctDate' && Utils.isNullOrEmptyString(param.controlValue)) {
                                param.controlValue = Utils.formatterNowToDate();
                            } else if (param.controlType == 'ctCombo') {
                                param.controlValue = param.itemList.find(x => x.Key == param.controlValue)
                            } 
                            this.filters.push({...param});
                        });
                        
                        this.filters.reverse();
                        if (this.filters.length == 0) {
                            setTimeout(() => this.search(), 50);
                        } else {
                            setTimeout(() => {
                                this.fields.push({ key: 'label', sortable: false, label: this.fieldTile, class: 'text-rigth' });
                            }, 10);
                        }
                    }

                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }
            )
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        pageChanged (page) {            
            this.currentPage = page;    
            this.search();    
        },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.search();
        },

        generateFields() {
            if (this.resetField) {
                this.resetField = false;
                this.fields = [];
            }

            if (this.fields.length == 0) {
                this.dataColumns.forEach(col => {
                    this.fields.push({ key: col.key , sortable: true, label: col.label, class: this.getClass(col) });
                });

                this.onSetField();
            }
        },

        getClass(column) {
            switch(column.dataType) {
                case 'numeric':
                case 'money':
                    return 'text-rigth';
            }
            return 'text-wrap';
        },
                        
        populateItems() {
            this.items = [];
            this.dataRows.forEach(row => {
                let newRow = {...row};
                this.items.push(newRow);
            });
        },

        onSetField(){  
            EventBus.$emit('onSetField', this.fields);   
        },

        validateFilters() {
            let isValid = true;
            this.filters.forEach((param, index) => {
                if (param.controlType == 'ctDate') {
                    const refs = this.$refs['ctDate_' + index];
                    param.isValid = !Utils.isNullOrEmptyString(param.controlValue) && refs[0].editIsValid()
                }

                isValid &= param.isValid;
            });

            return isValid;
        },

        changeDropDown(e, filter) {
            filter.controlValue = e;
        },

        onDatePressEnter() {
            console.log('onDatePressEnter')
            this.search();
        }
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }    

        await this.getCustomExports();

        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
    }
}
</script>